
import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import GuestListPage from './pages/GuestListPage';
import WatchListPage from './pages/WatchListPage';
import WalletPage from './pages/WalletPage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import NotificationsPage from './pages/NotificationsPage';

function App() {
  return (
    <div> 
      <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/guests" element={<GuestListPage />} />
          <Route path="/watchlist" element={<WatchListPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/notification" element={<NotificationsPage />} />
      </Routes>
    </div>
  );
}

export default App;
